import React from 'react';
import { MdMenu, MdNotifications } from 'react-icons/md';
import { FaUserCircle } from 'react-icons/fa';

const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const username = localStorage.getItem("username") || "Operator";
  const role = localStorage.getItem("role") || "guest";

  const roleLabel =
    role === "superAdmin"
      ? "Super Admin"
      : role === "admin"
      ? "Admin"
      : role === "branchUser"
      ? "Center Staff"
      : "Guest";

  const formattedDate = new Date().toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric"
  });

  return (
    <>
      <style>{`
        .app-header-wrap {
          background: #FFFFFF;
          border-bottom: 1px solid #E5E7EB;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          position: fixed;
          top: 0;
          right: 0;
          left: 0;
          z-index: 40;
          font-family: 'Inter', sans-serif;
        }
        @media (min-width: 1024px) {
          .app-header-wrap {
            left: 256px; /* Offset for sidebar width */
          }
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .header-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .breadcrumb-title {
          font-size: 14px;
          font-weight: 600;
          color: #111827;
        }
        .breadcrumb-sub {
          color: #667085;
          font-weight: 400;
        }
        .header-date {
          font-size: 13px;
          color: #667085;
          font-weight: 500;
          display: none;
        }
        @media (min-width: 640px) {
          .header-date {
            display: block;
          }
        }
        .notification-btn {
          background: transparent;
          border: none;
          color: #667085;
          font-size: 20px;
          cursor: pointer;
          position: relative;
          padding: 6px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.15s;
        }
        .notification-btn:hover {
          background: #F3F4F6;
          color: #111827;
        }
        .notification-badge {
          width: 8px;
          height: 8px;
          background: #DC2626;
          border-radius: 50%;
          position: absolute;
          top: 6px;
          right: 6px;
          border: 2px solid #FFFFFF;
        }
        .profile-section {
          display: flex;
          align-items: center;
          gap: 10px;
          border-left: 1px solid #E5E7EB;
          padding-left: 16px;
        }
        .profile-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .profile-name {
          font-size: 13px;
          font-weight: 600;
          color: #111827;
          max-width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .profile-role-badge {
          font-size: 10px;
          font-weight: 700;
          color: #16879A;
          background: #E6F7FA;
          padding: 1px 6px;
          border-radius: 4px;
          margin-top: 1px;
          text-transform: uppercase;
          letter-spacing: 0.02em;
        }
      `}</style>

      <header className="app-header-wrap">
        <div className="header-left">
          {/* Mobile menu toggle */}
          <button
            className="lg:hidden text-2xl text-gray-600 hover:text-gray-900 cursor-pointer focus:outline-none"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <MdMenu />
          </button>

          {/* Page context/title */}
          <div className="flex items-center gap-2">
            <span className="breadcrumb-title">
              Dashboard <span className="breadcrumb-sub">/ Overview</span>
            </span>
          </div>
        </div>

        <div className="header-right">
          {/* Current Date */}
          <div className="header-date">
            {formattedDate}
          </div>

          {/* Notifications */}
          <button className="notification-btn" aria-label="Notifications">
            <MdNotifications />
            <span className="notification-badge" />
          </button>

          {/* User profile */}
          <div className="profile-section">
            <FaUserCircle className="text-gray-400 text-2xl flex-shrink-0" />
            <div className="profile-info">
              <span className="profile-name" title={username}>{username}</span>
              <span className="profile-role-badge">{roleLabel}</span>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
